import { useQuery } from '@tanstack/react-query'

import { api } from '../../lib/api'
import type { TicketSummary } from '../../lib/types'
import { Card, Spinner, StatusBadge, formatDate } from '../../lib/ui'

export function Changes() {
  const { data, isLoading } = useQuery({
    queryKey: ['changes'],
    queryFn: () => api.get<TicketSummary[]>('/changes/'),
  })

  return (
    <div className="space-y-4">
      <div>
        <h1 className="text-2xl font-semibold text-slate-900">Change calendar</h1>
        <p className="mt-1 text-sm text-slate-500">
          Planned changes affecting services in your organisation. Read-only.
        </p>
      </div>

      {isLoading ? (
        <Spinner />
      ) : (data?.length ?? 0) === 0 ? (
        <Card>
          <p className="text-sm text-slate-500">No changes are scheduled.</p>
          {/* Scheduling windows arrive with change_request in Phase 6. */}
          <p className="mt-1 text-xs text-slate-400">
            Scheduled start and end times will appear here once change management is in place.
          </p>
        </Card>
      ) : (
        <Card className="p-0">
          <ul className="divide-y divide-slate-100">
            {data?.map((change) => (
              <li key={change.ref} className="px-5 py-3">
                <div className="flex items-center gap-3">
                  <span className="font-mono text-xs text-slate-400">{change.ref}</span>
                  <span className="flex-1 truncate text-sm text-slate-800">{change.title}</span>
                  <StatusBadge status={change.status} />
                </div>
                <p className="mt-1 text-xs text-slate-400">
                  {change.service ? `${change.service.service} · ` : ''}
                  Raised {formatDate(change.created_at)}
                </p>
              </li>
            ))}
          </ul>
        </Card>
      )}
    </div>
  )
}
